import type { ThumbnailSize, TooltipCommonProps } from '@wix/design-system';
import { Box, FormField, Thumbnail } from '@wix/design-system';
import React, { useContext } from 'react';

import { ZIndexContext } from './../../ricos-context';
import type { LogBiFn } from './../../_shared/bi-context-provider/bi-context-provider';

import classes from './thumbnail-picker-scss';

export type ThumbnailPickerProps = {
  selectedValue: string | number | undefined;
  size?: ThumbnailSize;
  title?: string;
  titleInfoContent?: React.ReactNode;
  onChange: (value: string | number) => void;
  dataSource: {
    value: string | number;
    dataHook: string;
    renderBackgroundImage: (props: { width: string; height: string }) => React.ReactNode;
    label?: string;
  }[];
  tooltipAppendTo?: TooltipCommonProps['appendTo'];
  dataHook: string;
  logBi: LogBiFn;
};

export const ThumbnailPicker: React.FC<ThumbnailPickerProps> = ({
  title,
  titleInfoContent,
  selectedValue,
  onChange,
  dataSource,
  tooltipAppendTo,
  size = 'tiny',
  dataHook,
  logBi,
}) => {
  const zIndexService = useContext(ZIndexContext);

  return (
    <FormField
      label={title}
      infoContent={titleInfoContent}
      infoTooltipProps={{
        appendTo:
          tooltipAppendTo ??
          (el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal'))),
        zIndex: zIndexService.getZIndex('TOOLTIP'),
      }}
      dataHook={dataHook}
    >
      <div className={classes.container}>
        {dataSource.map(({ value, dataHook: thumbnailDataHook, renderBackgroundImage, label }) => (
          <Thumbnail
            key={value}
            size={size}
            selected={value === selectedValue}
            title={label ? label : undefined}
            onClick={() => {
              if (dataHook) {
                logBi?.({ dataHook, value });
              }
              onChange(value);
            }}
            dataHook={thumbnailDataHook}
            image={
              <Box height="100%" width="100%" align="center" verticalAlign="middle">
                {renderBackgroundImage({ width: '70%', height: '70%' })}
              </Box>
            }
            ellipsis
            textPosition="outside"
            tooltipProps={{
              appendTo:
                tooltipAppendTo ??
                (el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal'))),
              zIndex: zIndexService.getZIndex('TOOLTIP'),
              enterDelay: 1000,
            }}
          />
        ))}
      </div>
    </FormField>
  );
};
